import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { environment } from '../../environments/environment';
import { LocalStoreManager } from '../services/local-store-manager.service';
import { DBkeys } from '../services/db-keys';
import { Utilities } from '../services/utilities';

interface UserConfiguration {
  homeUrl: string;
}

@Injectable()
export class ConfigurationService {

  constructor(
    private localStorage: LocalStoreManager) {

    this.loadLocalChanges();
  }

  set homeUrl(value: string) {
    this._homeUrl = value;
    this.saveToLocalStore(value, DBkeys.HOME_URL);
  }
  get homeUrl() {
    return this._homeUrl || ConfigurationService.defaultHomeUrl;
  }

  public static readonly appVersion: string = '1.0.0';

  ///
  //
  public static readonly SETTING_CAPTCHA_SITEKEY = '6LfuiikTAAAAAPlFF7pGYHTWIsHfFSEbrzDvrSiu';
  public static readonly SETTING_GOOGLE_CLIENTID = '917993493150-8qcerehdr1fvopmovqn3n7nb9evs26i2.apps.googleusercontent.com'; // '912833426991-eoa2q0nscln9tok6kgvad19r13trn4k4.apps.googleusercontent.com';
  public static readonly SETTING_FACEBOOK_APPID = '1616181788654209'; //2848542655240681
  public static readonly SETTING_IP_API_KEY = 'bnydZG4lQUUHVPW';

  // ***Specify default configurations here***
  public static readonly defaultHomeUrl: string = '/';

  public baseUrl = environment.baseUrl || Utilities.baseUrl();
  public apiUrl = environment.tokenUrl || environment.baseUrl || Utilities.baseUrl();
  public loginUrl = environment.loginUrl;
  public homeApiUrl = environment.homeUrl;
  public professionalUrl = environment.professionalUrl;

  // public assetsPath = environment.assetsPath;
  public get assetsPath() {
    if (this.baseUrl == 'http://localhost:4200') {
      return './';
    }

    return environment.assetsPath;
  }

  public get apiPath() {
    return environment.apiUrl;
  }

  // ***End of defaults***

  // tslint:disable-next-line: variable-name
  private _homeUrl: string = null;

  private onConfigurationImported: Subject<boolean> = new Subject<boolean>();
  configurationImported$ = this.onConfigurationImported.asObservable();



  private loadLocalChanges() {

    if (this.localStorage.exists(DBkeys.HOME_URL)) {
      this._homeUrl = this.localStorage.getDataObject<string>(DBkeys.HOME_URL);
    }
  }


  private saveToLocalStore(data: any, key: string) {
    setTimeout(() => this.localStorage.savePermanentData(data, key));
  }


  public import(jsonValue: string) {

    this.clearLocalChanges();

    if (jsonValue) {
      const importValue: UserConfiguration = Utilities.JsonTryParse(jsonValue);

      if (importValue.homeUrl != null) {
        this.homeUrl = importValue.homeUrl;
      }
    }

    this.onConfigurationImported.next();
  }


  public export(changesOnly = true): string {

    const exportValue: UserConfiguration = {
      homeUrl: changesOnly ? this._homeUrl : this.homeUrl
    };

    return JSON.stringify(exportValue);
  }


  public clearLocalChanges() {
    this._homeUrl = null;

    this.localStorage.deleteData(DBkeys.HOME_URL);
  }
}
